// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3wpNO","col":"CardReaderDesc_col__13GOG","label":"CardReaderDesc_label__2ZJmw"};